var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalCheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A0B2F;}\n\t.st1{fill:#7BC9A1;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.53,489.17H93.94c-46.44,0-84.08-37.64-84.08-84.08V92.49c0-46.44,37.64-84.08,84.08-84.08h312.59 c46.44,0,84.08,37.64,84.08,84.08v312.59C490.61,451.52,452.96,489.17,406.53,489.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.15,183.38l2.27,258.38c59.92-1.43,107.81-59.33,107.18-130.15C191.98,240.81,143.09,183.76,83.15,183.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.65,316l-2.37-270.07c-59.98,1.48-107.87,61.97-107.22,136C83.71,255.92,132.66,315.57,192.65,316"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.15,373.66l8.78-55.22h11.69c7.36,0,12.79,1.71,16.28,5.14s5.24,8.74,5.24,15.92 c0,5.55-0.86,10.9-2.59,16.06s-3.95,9.12-6.68,11.9c-2.22,2.24-4.77,3.84-7.64,4.78c-2.87,0.95-7.36,1.42-13.47,1.42L209.15,373.66 L209.15,373.66z M226.85,360.05c0.1,0.03,0.21,0.04,0.32,0.06c0.11,0.01,0.28,0.02,0.51,0.02c0.91,0,1.77-0.21,2.59-0.64 s1.51-1.02,2.06-1.78c0.91-1.21,1.78-3.68,2.61-7.39s1.25-7.42,1.25-11.1c0-2.4-0.38-4.15-1.15-5.28 c-0.77-1.12-2.01-1.75-3.73-1.87L226.85,360.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.78,373.66l8.74-55.22h15.43l-8.78,55.22H251.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.92,341.74h19.74c-0.43,11.2-2.57,19.5-6.43,24.91c-3.86,5.41-9.56,8.11-17.1,8.11 c-5.85,0-10.31-1.8-13.37-5.39c-3.06-3.59-4.6-8.79-4.6-15.6c0-5.32,0.64-10.39,1.91-15.21c1.27-4.82,3.06-8.91,5.35-12.29 c1.99-2.95,4.49-5.18,7.49-6.68s6.44-2.25,10.33-2.25c4.84,0,8.78,1.13,11.82,3.39s4.96,5.49,5.77,9.7l-14.18,5.26 c-0.4-1.74-0.93-2.96-1.57-3.65s-1.53-1.04-2.67-1.04c-1.19,0-2.22,0.42-3.1,1.25s-1.64,2.12-2.27,3.86 c-0.86,2.45-1.61,5.59-2.27,9.44c-0.66,3.85-0.98,7.15-0.98,9.93c0,2.12,0.3,3.61,0.89,4.48c0.59,0.87,1.59,1.3,3.01,1.3 c1.74,0,3.13-0.74,4.18-2.23c1.05-1.49,1.66-3.61,1.83-6.35h-5.26L297.92,341.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.08,373.66l8.74-55.22h15.43l-8.78,55.22H318.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.6,373.66h-15.51l6.51-41.23h-9.19l2.23-13.99h33.85l-2.23,13.99h-9.15L362.6,373.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.9,373.66l20.77-55.22h18.19l3.9,55.22h-15.58l0.08-8.13h-9.12l-2.42,8.13H369.9z M391.38,354.37h6.17 l0.19-20.46L391.38,354.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.46,373.66l8.78-55.22h15.47l-6.58,41.53h11.31l-2.16,13.69H414.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.22,397.48c-0.91-0.48-1.77-0.82-2.57-1.02c-0.81-0.2-1.63-0.3-2.46-0.3c-3.61,0-6.51,1.72-8.7,5.16 s-3.29,8.01-3.29,13.71c0,3.66,0.66,6.37,1.99,8.13c1.32,1.77,3.35,2.65,6.07,2.65c0.66,0,1.37-0.07,2.14-0.21 c0.77-0.14,1.58-0.35,2.44-0.62l-2.35,13.31c-1.06,0.43-2.21,0.74-3.44,0.95c-1.24,0.2-2.65,0.3-4.24,0.3 c-6.23,0-10.99-1.82-14.28-5.45s-4.94-8.9-4.94-15.81c0-10.82,2.5-19.52,7.49-26.12c4.99-6.59,11.61-9.89,19.86-9.89 c1.51,0,2.99,0.13,4.43,0.4c1.44,0.26,2.86,0.65,4.27,1.15L243.22,397.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.29,438.52l8.78-55.22h15.39l-3.18,19.97h6.35l3.1-19.97h15.43l-8.78,55.22H263l3.4-21.6h-6.28l-3.4,21.6 H241.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.75,438.52l8.78-55.22h27.35l-2.12,13.39h-11.91l-1.17,7.04h10.78l-2,12.94h-10.78l-1.25,7.6h11.95 l-2.27,14.26h-27.36V438.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.99,397.48c-0.91-0.48-1.77-0.82-2.57-1.02c-0.81-0.2-1.63-0.3-2.46-0.3c-3.61,0-6.51,1.72-8.7,5.16 s-3.29,8.01-3.29,13.71c0,3.66,0.66,6.37,1.99,8.13c1.33,1.76,3.35,2.65,6.07,2.65c0.66,0,1.37-0.07,2.14-0.21 c0.77-0.14,1.58-0.35,2.44-0.62l-2.35,13.31c-1.06,0.43-2.21,0.74-3.44,0.95c-1.24,0.2-2.65,0.3-4.24,0.3 c-6.23,0-10.99-1.82-14.28-5.45c-3.29-3.63-4.94-8.9-4.94-15.81c0-10.82,2.5-19.52,7.49-26.12c4.99-6.59,11.61-9.89,19.86-9.89 c1.51,0,2.99,0.13,4.43,0.4c1.44,0.27,2.86,0.65,4.27,1.15L352.99,397.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351.06,438.52l8.78-55.22h15.39l-3.63,23.07l12.18-23.07h15.7l-15.32,25.49l6.96,29.73H374.4l-3.9-25.11 l-4.01,25.11L351.06,438.52L351.06,438.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCheque);
export default __webpack_public_path__ + "static/media/DigitalCheque.6dd7f5ba1fece7f990631a58613e03ce.svg";
export { ForwardRef as ReactComponent };